import React, { useEffect, useState } from 'react';
import { Label, Select, Input } from '@xometry/xometry_loft';

export const CustomerRole = (props) => {
  const {
    handleBlur,
    handleChange,
    disabled,
    customerRoleValue,
    customerRoleOtherValue,
  } = props;

  const [isOther, setIsOther] = useState(false);
  const [currentCustomerRoleValue, setCurrentCustomerRoleValue] =
    useState(customerRoleValue);
  const [currentCustomerRoleOtherValue, setCurrentCustomerRoleOtherValue] =
    useState(customerRoleOtherValue);

  const roleOptions = [
    'Engineer',
    'Engineering Management',
    'Designer',
    'Design Management',
    'Purchasing / Buyer / Finance',
    'Program / Project Management',
    'Operations / MRO Management',
    'Executive Leadership (CXO, VP, founder, etc.)',
    'Sales & Marketing',
    'Other',
  ];

  useEffect(() => {
    if (customerRoleValue && !roleOptions.includes(customerRoleValue)) {
      setCurrentCustomerRoleOtherValue(customerRoleOtherValue);
      setCurrentCustomerRoleValue('Other');
      setIsOther(true);
    } else {
      setCurrentCustomerRoleValue(customerRoleValue);
      setCurrentCustomerRoleOtherValue(null);
    }
  }, [customerRoleValue, customerRoleOtherValue]);

  const checkIsOther = (event) => {
    if (event.target.value === 'Other') {
      setIsOther(true);
    } else {
      setIsOther(false);
    }

    handleChange(event);
  };

  return (
    <>
      <Label size="medium" htmlFor="customerRole">
        Customer Role (optional)
      </Label>
      <Select
        id="customerRole"
        name="customerRole"
        scale="medium"
        onChange={checkIsOther}
        disabled={disabled}
        value={currentCustomerRoleValue}
        style={{ width: '100%' }}
      >
        <option></option>
        <option>Engineer</option>
        <option>Engineering Management</option>
        <option>Designer</option>
        <option>Design Management</option>
        <option>Purchasing / Buyer / Finance</option>
        <option>Program / Project Management</option>
        <option>Operations / MRO Management</option>
        <option>Executive Leadership (CXO, VP, founder, etc.)</option>
        <option>Sales & Marketing</option>
        <option>Other</option>
      </Select>
      {isOther && (
        <Input
          id="customerRoleOther"
          name="customerRoleOther"
          type="text"
          value={currentCustomerRoleOtherValue}
          onChange={handleChange}
          disabled={disabled}
          onBlur={handleBlur}
          placeholder="Please specify"
        />
      )}
    </>
  );
};
